// ** MUI Imports
import Box from '@mui/material/Box'

// ** Type Import
import {Settings} from 'src/@core/context/settingsContext'

// ** Components
import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import NotificationDropdown from '../../../@core/layouts/components/shared-components/NotificationDropdown'
import LanguageDropdown from '../../../@core/layouts/components/shared-components/LanguageDropdown'


interface Props {
    settings: Settings
    saveSettings: (values: Settings) => void
}

const AppBarContent = (props: Props) => {
    // ** Props
    const {settings, saveSettings} = props

    return (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <ModeToggler settings={settings} saveSettings={saveSettings}/>
            {/*<NotificationDropdown settings={settings}/>*/}
            <UserDropdown settings={settings}/>
        </Box>
    )
}

export default AppBarContent
